"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkScope = void 0;
var _1 = require(".");
var checkScope = function (value, min, max) {
    var _a, _b;
    if (!(value === null || value === void 0 ? void 0 : value.start) || !(value === null || value === void 0 ? void 0 : value.end))
        return { startOutOfScope: false, endOutOfScope: false };
    var start = _1.toDateFormat.startOfDay(value.start);
    var end = _1.toDateFormat.endOfDay(value.end);
    var startOutOfScope = (start === null || start === void 0 ? void 0 : start.getTime()) < ((_a = _1.toDateFormat.startOfDay(min)) === null || _a === void 0 ? void 0 : _a.getTime());
    var endOutOfScope = (end === null || end === void 0 ? void 0 : end.getTime()) > ((_b = _1.toDateFormat.endOfDay(max)) === null || _b === void 0 ? void 0 : _b.getTime());
    return { startOutOfScope: startOutOfScope, endOutOfScope: endOutOfScope };
};
exports.checkScope = checkScope;
//# sourceMappingURL=checkScope.js.map